// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout';
var marketingRouter = {
  path: '/marketing',
  component: Layout,
  redirect: '/marketing/integral/integralconfig',
  name: 'Marketing',
  meta: {
    title: '营销',
    icon: 'clipboard'
  },
  children: [{
    path: 'coupon',
    component: function component() {
      return import('@/views/marketing/coupon/index');
    },
    name: 'Coupon',
    meta: {
      title: '优惠券',
      icon: ''
    },
    children: [{
      path: 'template',
      component: function component() {
        return import('@/views/marketing/coupon/couponTemplate/index');
      },
      name: 'couponTemplate',
      hidden: true,
      meta: {
        title: '优惠券模板',
        icon: ''
      }
    }, {
      path: 'list/save/:id?',
      name: 'couponAdd',
      meta: {
        title: '优惠劵添加',
        noCache: true,
        activeMenu: "/marketing/coupon/list"
      },
      hidden: true,
      component: function component() {
        return import('@/views/marketing/coupon/list/creatCoupon');
      }
    }, {
      path: 'list',
      component: function component() {
        return import('@/views/marketing/coupon/list/index');
      },
      name: 'List',
      meta: {
        title: '优惠券列表',
        icon: ''
      }
    }, {
      path: 'record',
      component: function component() {
        return import('@/views/marketing/coupon/record/index');
      },
      name: 'Record',
      meta: {
        title: '领取记录',
        icon: ''
      }
    }]
  }, {
    path: 'productCoupon',
    component: function component() {
      return import('@/views/marketing/productCoupon/index');
    },
    name: 'ProductCoupon',
    meta: {
      title: '神券',
      icon: ''
    },
    children: [{
      path: 'list/add/:id?',
      name: 'productCouponAdd',
      meta: {
        title: '神券添加',
        noCache: true,
        activeMenu: "/marketing/productCoupon/list"
      },
      hidden: true,
      component: function component() {
        return import('@/views/marketing/productCoupon/list/creatCoupon');
      }
    }, {
      path: 'list/edit/:id?',
      name: 'productCouponEdit',
      meta: {
        title: '神券编辑',
        noCache: true,
        activeMenu: "/marketing/productCoupon/list"
      },
      hidden: true,
      component: function component() {
        return import('@/views/marketing/productCoupon/list/creatCoupon');
      }
    }, {
      path: 'list',
      component: function component() {
        return import('@/views/marketing/productCoupon/list/index');
      },
      name: 'productCouponList',
      meta: {
        title: '神券列表',
        icon: ''
      }
    }, {
      path: 'order/index',
      component: function component() {
        return import('@/views/marketing/productCoupon/order/index');
      },
      name: 'productCouponOrder',
      meta: {
        title: '神券订单',
        icon: ''
      }
    }]
  }, {
    path: 'bargain',
    component: function component() {
      return import('@/views/marketing/bargain/index');
    },
    name: 'Bargain',
    meta: {
      title: '砍价管理',
      icon: ''
    },
    alwaysShow: true,
    hidden: true,
    children: [{
      path: 'bargainGoods',
      component: function component() {
        return import('@/views/marketing/bargain/bargainGoods/index');
      },
      name: 'bargainGoods',
      meta: {
        title: '砍价商品',
        icon: ''
      }
    }, {
      path: 'creatBargain/:id?',
      component: function component() {
        return import('@/views/marketing/bargain/bargainGoods/creatBargain');
      },
      name: 'creatBargain',
      meta: {
        title: '砍价商品',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/bargain/bargainGoods"
      }
    }, {
      path: 'bargainList',
      component: function component() {
        return import('@/views/marketing/bargain/bargainList/index');
      },
      name: 'bargainList',
      meta: {
        title: '砍价列表',
        icon: ''
      }
    }]
  }, {
    path: 'groupBuy',
    component: function component() {
      return import('@/views/marketing/groupBuy/index');
    },
    name: 'groupBuy',
    meta: {
      title: '拼团管理',
      icon: ''
    },
    hidden: true,
    children: [{
      path: 'groupGoods',
      component: function component() {
        return import('@/views/marketing/groupBuy/groupGoods/index');
      },
      name: 'groupGoods',
      meta: {
        title: '拼团商品',
        icon: ''
      }
    }, {
      path: 'creatGroup/:id?/:type?',
      component: function component() {
        return import('@/views/marketing/groupBuy/groupGoods/creatGroup');
      },
      name: 'creatGroup',
      meta: {
        title: '拼团商品',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/groupBuy/groupGoods"
      }
    }, {
      path: 'groupList',
      component: function component() {
        return import('@/views/marketing/groupBuy/groupList/index');
      },
      name: 'groupList',
      meta: {
        title: '拼团列表',
        icon: ''
      }
    }]
  }, {
    path: 'seckill',
    component: function component() {
      return import('@/views/marketing/seckill/index');
    },
    name: 'Seckill',
    meta: {
      title: '秒杀管理',
      icon: ''
    },
    children: [{
      path: 'config',
      component: function component() {
        return import('@/views/marketing/seckill/seckillConfig/index');
      },
      name: 'SeckillConfig',
      meta: {
        title: '秒杀配置',
        icon: ''
      }
    }, {
      path: 'list/:timeId?',
      component: function component() {
        return import('@/views/marketing/seckill/seckillList/index');
      },
      name: 'SeckillList',
      meta: {
        title: '秒杀商品',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/seckill/list"
      }
    }, {
      path: 'creatSeckill/:name?/:timeId?/:id?',
      component: function component() {
        return import('@/views/marketing/seckill/seckillList/creatSeckill');
      },
      name: 'CreatSeckill',
      meta: {
        title: '添加秒杀商品',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/seckill/list"
      }
    }]
  }, {
    path: 'integral',
    component: function component() {
      return import('@/views/marketing/integral/index');
    },
    name: 'Integral',
    meta: {
      title: '积分',
      icon: ''
    },
    children: [{
      path: 'integralconfig',
      component: function component() {
        return import('@/views/marketing/integral/config/index');
      },
      name: 'integralConfig',
      meta: {
        title: '积分配置',
        icon: ''
      }
    }, {
      path: 'integrallog',
      component: function component() {
        return import('@/views/marketing/integral/integralLog/index');
      },
      name: 'integralLog',
      meta: {
        title: '积分日志',
        icon: ''
      }
    }, {
      path: 'product/index',
      component: function component() {
        return import('@/views/marketing/integral/product/index');
      },
      name: 'IntegralProduct',
      meta: {
        title: '积分商品',
        icon: ''
      }
    }, {
      path: 'product/form/index',
      component: function component() {
        return import('@/views/marketing/integral/product/form/index');
      },
      name: 'IntegralProductFrom',
      meta: {
        title: '积分商品编辑/添加',
        icon: '',
        activeMenu: "/marketing/integral/product/index"
      }
    }, {
      path: 'product/order/index',
      component: function component() {
        return import('@/views/marketing/integral/product/order/index');
      },
      name: 'IntegralProductOrder',
      meta: {
        title: '积分商品订单',
        icon: ''
      }
    }]
  }, {
    path: 'sign',
    component: function component() {
      return import('@/views/marketing/sign/index');
    },
    name: 'Sign',
    meta: {
      title: '签到',
      icon: ''
    },
    children: [{
      path: 'signconfig',
      component: function component() {
        return import('@/views/marketing/sign/config/index');
      },
      name: 'signConfig',
      meta: {
        title: '签到配置',
        icon: ''
      }
    }
    // {
    //   path: 'signlog',
    //   component: () => import('@/views/marketing/sign/signLog/index'),
    //   name: 'signLog',
    //   meta: { title: '签到日志', icon: '' },
    // },
    ]
  }, {
    path: 'atmosphere',
    name: 'atmosphere',
    meta: {
      title: '活动氛围',
      noCache: true
    },
    component: function component() {
      return import('@/views/marketing/atmosphere/index');
    },
    children: [{
      path: 'list',
      name: "atmosphereList",
      meta: {
        title: '氛围列表',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/atmosphere/atmosphereList/list');
      }
    }, {
      path: 'add/:id?',
      name: "addAtmosphere",
      meta: {
        title: '添加活动氛围',
        noCache: true,
        activeMenu: "/marketing/atmosphere/list"
      },
      component: function component() {
        return import('@/views/marketing/atmosphere/atmosphereList/addAtmosphere');
      }
    }]
  }, {
    path: 'border',
    name: 'border',
    meta: {
      title: '活动边框',
      icon: ''
    },
    component: function component() {
      return import('@/views/marketing/border/index');
    },
    children: [{
      path: 'list',
      name: "borderList",
      meta: {
        title: '活动边框列表',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/atmosphere/atmosphereList/list');
      }
    }, {
      path: 'add/:id?',
      name: "addBorder",
      meta: {
        title: '添加活动边框',
        noCache: true,
        activeMenu: "/marketing/border/list"
      },
      component: function component() {
        return import('@/views/marketing/atmosphere/atmosphereList/addAtmosphere');
      }
    }]
  }, {
    path: 'questionnaire',
    name: 'questionnaire',
    meta: {
      title: '问卷管理',
      icon: ''
    },
    component: function component() {
      return import('@/views/marketing/questionnaire/index');
    },
    children: [{
      path: 'list',
      name: "questionnaireList",
      meta: {
        title: '问卷列表'
      },
      component: function component() {
        return import('@/views/marketing/questionnaire/list/index');
      }
    }, {
      path: 'form',
      name: "questionnaireForm",
      meta: {
        title: '问卷编辑/添加',
        activeMenu: "/marketing/questionnaire/list"
      },
      component: function component() {
        return import('@/views/marketing/questionnaire/form/index');
      }
    }, {
      path: 'question',
      name: "Question",
      meta: {
        title: '问卷问题列表',
        activeMenu: "/marketing/questionnaire/list"
      },
      component: function component() {
        return import('@/views/marketing/questionnaire/question/index');
      }
    }, {
      path: 'question/form',
      name: "QuestionForm",
      meta: {
        title: '问卷问题编辑/添加',
        noCache: true,
        activeMenu: "/marketing/questionnaire/list"
      },
      component: function component() {
        return import('@/views/marketing/questionnaire/question/form/index');
      }
    }, {
      path: 'answer/log',
      name: "AnswerLog",
      meta: {
        title: '问卷回答日志',
        noCache: true,
        activeMenu: "/marketing/questionnaire/answer/log"
      },
      component: function component() {
        return import('@/views/marketing/questionnaire/answerLog/index');
      }
    }]
  }, {
    path: 'welfare',
    name: 'welfare',
    meta: {
      title: '福利管理',
      icon: ''
    },
    component: function component() {
      return import('@/views/marketing/welfare/index');
    },
    children: [{
      path: 'list',
      name: "welfareList",
      meta: {
        title: '福利列表'
      },
      component: function component() {
        return import('@/views/marketing/welfare/list/index');
      }
    }, {
      path: 'form',
      name: "welfareForm",
      meta: {
        title: '福利编辑/添加',
        activeMenu: "/marketing/welfare/list"
      },
      component: function component() {
        return import('@/views/marketing/welfare/form/index');
      }
    }, {
      path: 'lottery',
      name: "welfareLottery",
      meta: {
        title: '福利奖品列表',
        activeMenu: "/marketing/welfare/list"
      },
      component: function component() {
        return import('@/views/marketing/welfare/lottery/index');
      }
    }, {
      path: 'lottery/form',
      name: "welfareLotteryForm",
      meta: {
        title: '福利奖品编辑/添加',
        activeMenu: "/marketing/welfare/list"
      },
      component: function component() {
        return import('@/views/marketing/welfare/lottery/form/index');
      }
    }, {
      path: 'lotteryLog',
      name: "welfareLotteryLogList",
      meta: {
        title: '福利奖品日志列表'
      },
      component: function component() {
        return import('@/views/marketing/welfare/lotteryLog/index');
      }
    }]
  }, {
    path: 'activity',
    name: 'activity',
    meta: {
      title: '活动管理',
      icon: ''
    },
    component: function component() {
      return import('@/views/marketing/activity/index');
    },
    children: [{
      path: 'list',
      name: "activityList",
      meta: {
        title: '活动列表'
      },
      component: function component() {
        return import('@/views/marketing/activity/list/index');
      }
    }, {
      path: 'form',
      name: "activityForm",
      meta: {
        title: '活动编辑/添加',
        activeMenu: "/marketing/activity/list"
      },
      component: function component() {
        return import('@/views/marketing/activity/form/index');
      }
    }, {
      path: 'log',
      name: "ActivityLog",
      meta: {
        title: '活动参加记录'
      },
      component: function component() {
        return import('@/views/marketing/activity/log/index');
      }
    }]
  }, {
    path: 'parkinglot',
    name: 'parkinglot',
    meta: {
      title: '停车场',
      icon: ''
    },
    component: function component() {
      return import('@/views/marketing/parkinglot/index');
    },
    children: [{
      path: 'coupon',
      name: "parkinglotCouponList",
      meta: {
        title: '停车券列表'
      },
      component: function component() {
        return import('@/views/marketing/parkinglot/coupon/index');
      }
    }, {
      path: 'coupon/form',
      name: "parkinglotCouponForm",
      meta: {
        title: '停车券编辑/添加',
        activeMenu: "/marketing/parkinglot/coupon"
      },
      component: function component() {
        return import('@/views/marketing/parkinglot/coupon/form/index');
      }
    }, {
      path: 'coupon/log',
      name: "parkinglotCouponLogList",
      meta: {
        title: '停车券领取记录'
      },
      component: function component() {
        return import('@/views/marketing/parkinglot/coupon/log/index');
      }
    }, {
      path: 'order',
      name: "parkinglotOrderList",
      meta: {
        title: '停车订单列表'
      },
      component: function component() {
        return import('@/views/marketing/parkinglot/order/index');
      }
    }]
  }, {
    path: 'referral_rewards',
    name: 'referral_rewards',
    meta: {
      title: '推荐有礼',
      icon: ''
    },
    component: function component() {
      return import('@/views/marketing/referralRewards/index');
    }
  }]
};
export default marketingRouter;